import { Component, Input, OnInit } from '@angular/core';
import { UserDataService } from '../../../../../shared/services/user-data/user-data.service';
import {
  ECONOMIC_STUDY_NAME,
  MIN_STATUS,
  RESULT_NAME,
} from '../../../../../shared/utils/constants';
import { YourRequestSectionModel } from '../../../../models/your-request-section.model';
import { DashboardSectionService } from '../../../../services/dashboard-section/dashboard-section.service';

@Component({
  selector: 'app-your-request-section',
  templateUrl: './your-request-section.component.html',
  styleUrls: ['./your-request-section.component.scss'],
  standalone: false,
})
export class YourRequestSectionComponent implements OnInit {
  @Input() status: number;
  @Input() isRejected: boolean;

  public ECONOMIC_STUDY_NAME = ECONOMIC_STUDY_NAME;
  public RESULT_NAME = RESULT_NAME;
  public requestData: YourRequestSectionModel;
  public holder1: string;
  public holder2: string;
  public httpError: boolean;
  public minStatus = MIN_STATUS;

  constructor(
    private dashboardSectionService: DashboardSectionService,
    private _userDataService: UserDataService,
  ) {}

  ngOnInit() {
    this.getYourRequestData();
  }

  private getYourRequestData() {
    this.dashboardSectionService.getYourRequestSectionData().subscribe(
      (response) => {
        this.requestData = response;
        if (this.requestData.holders) {
          this.holder1 = this.requestData.holders[0];
        }
        if (this.requestData.holders && this.requestData.holders.length > 1) {
          this.holder2 = this.requestData.holders[1];
        }
      },
      (error) => {
        this.httpError = true;
      },
    );
  }
}
